
import {Progress, Typography} from "antd";
import LogoComponent from "@/assets/logoComponent.tsx";

const {Text, Title} = Typography;

function LoadingMark({size = "md"}: {size?: "sm" | "md"}) {
    const wrapperClass = size === "sm" ? "w-12!" : "w-16!";
    const logoClass = size === "sm" ? "w-10!" : "w-14!";

    return (
        <div className={`loader ${wrapperClass} bg-transparent!`}>
            <LogoComponent className={`${logoClass} mx-auto animate-spin text-primary dark:text-accent`}/>
        </div>
    );
}

export interface TaskProgressState {
    progress: number;
    step: string;
    detail?: string;
}

export default function LoadingScreen() {
    return <div className="flex h-screen w-full items-center justify-center">
        <LoadingMark/>
    </div>;
}

export function TaskLoadingOverlay({
                                       title,
                                       progress,
                                       step,
                                       detail
                                   }: {
    title: string;
    progress: number;
    step: string;
    detail?: string;
}) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4 backdrop-blur-xl">
            <div className="glass-card w-full max-w-md overflow-hidden rounded-3xl border border-black/10 bg-light-accent p-5 shadow-2xl shadow-black/20 dark:border-white/10 dark:bg-dark sm:p-6">
                <div className="mb-5 flex items-center gap-4">
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-primary/10 bg-white/70 shadow-sm dark:border-white/10 dark:bg-black/20">
                        <LoadingMark size="sm"/>
                    </div>
                    <div className="min-w-0">
                        <Text className="block text-[11px]! uppercase tracking-[0.22em] text-primary/65 dark:text-accent/70">
                            Processing
                        </Text>
                        <Title level={5} className="mb-0! mt-1! truncate text-primary dark:text-white">
                            {title}
                        </Title>
                        <Text className="block truncate text-primary/70 dark:text-white/60">
                            {step}
                        </Text>
                    </div>
                </div>

                <Progress
                    percent={Math.max(0, Math.min(100, Math.round(progress)))}
                    status="active"
                    strokeColor="var(--color-primary)"
                    railColor="rgba(0, 124, 138, 0.12)"
                    className="mb-2"
                />

                {detail ? (
                    <Text className="block text-sm text-primary/65 dark:text-white/55">
                        {detail}
                    </Text>
                ) : null}
            </div>
        </div>
    );
}
